function MedalType({ type, athletes }) {
  return (
    <div className="p-5 sm:p-6">
      <div className="mb-4 flex items-center justify-center gap-2">
        <span
          className={`items-center text-xl fas fa-medal fa-2x medal-${type}`}
        ></span>
      </div>

      <div className="gap-x-8 gap-y-4 text-center">
        {athletes.map((athlete, index) => (
          <div key={index} className="">
            <span className="medal-athlete-name">{athlete.athleteName}</span>
            <span> - </span>
            <span className="medal-athlete-speciality">
              {athlete.speciality}
            </span>
          </div>
        ))}
      </div>
      {/* <div className="grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-x-8 gap-y-4 text-center">
        {athletes.map((athlete, index) => (
          <div key={index} className="">
            <p className="medal-athlete-name">{athlete.athleteName}</p>
            <p className="medal-athlete-speciality">{athlete.speciality}</p>
          </div>
        ))}
      </div> */}
    </div>
  );
}

export default MedalType;
